import styled from 'styled-components'
import { useDispatch } from 'react-redux'

import { DrawerBodyWrapper, DrawerFooterWrapper } from '@base'
import GSTAddressCard from './GSTAddressCard'
import { toggleDrawer } from '@data/state/action/root'

const AddressListWrapper = styled.div`
	display: flex;
	flex-direction: column;
`

const SelectGst = ({ updateCallback, addresses = [] }) => {
	const dispatch = useDispatch()

	const selectAddress = (address) => () => {
		updateCallback(address)
		dispatch(toggleDrawer(false))
	}
	return (
		<>
			<DrawerBodyWrapper>
				<AddressListWrapper>
					{addresses
						// ?.filter((item) => item?.address?.complete_address) TODO-> for complete address check
						?.map((item) => (
							<div onClick={selectAddress(item)}>
								<GSTAddressCard hoverable gst={item?.gst} address={item?.address} />
							</div>
						))}
				</AddressListWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper></DrawerFooterWrapper>
		</>
	)
}

export default SelectGst
